<template>
  <div :class="$style.container">

      <div :class="$style.left">
          <span>本次辅导内容</span>
          <span>{{item.coaching}}</span>
      </div>
      <div :class="$style.left">
          <span>后续跟进内容</span>
          <span>{{item.followup}}</span>
      </div>

      <div :class="$style.body">
          <Item :result=obj v-for="obj in item.info" :key="obj.courseTitle"/>
      </div>
  </div>
</template>
<script>
import Item from './item.vue'
export default {
  data () {
    return {
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },obj: {
      type: Object,
      default: () => {}
    }
  },
  components: {
      Item
  }
}
</script>
<style lang="scss" module>
  @import '../../../../assets/css/default';
  .container {
    margin: 10px 0px;
      .left {
          margin-bottom: 20px;
          span {
              &:nth-child(1) {
                  display: inline-block;
                  margin-right: 60px;
                  color: #000000;
                  font-size: 16px;
                  font-weight: bold;
              }
              &:nth-child(2) {
                  color: #4A90E2;
                  font-size: 16px;
              }
          }
      }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cruiseShop/assessment/item/tabItem.vue